import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3190a469"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "package-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "应用名称：天数AIOT物联网管理平台", -1))
const _hoisted_3 = { class: "exprieTime" }

import { ref } from 'vue'
import { CODE_ENUM } from '@/common'
import { queryTenantResource } from '@/api'
import { useRoute } from 'vue-router'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'resource',
  setup(__props) {

const $route = useRoute()
const tableData = ref([])

const orgId = $route.query.orgId

const fetchList = async () => {
  const res: any = await queryTenantResource({
    orgId,
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res.data
  }
}

fetchList()

const col = [
  {
    type: 'index',
    label: '序号',
    width: 80,
  },
  {
    prop: 'resourceName',
    label: '资源名称',
    width: '300',
  },
  {
    prop: 'resourceDescribe',
    label: '资源描述',
    formatter: ({ resourceDescribe }: any) => {
      return resourceDescribe || '-'
    },
  },
  // {
  //   prop: 'exprieTime',
  //   label: '到期时间',
  //   width: '400',
  //   formatter: ({ exprieTime }: any) => {
  //     return exprieTime === -1
  //       ? '无期限'
  //       : moment(exprieTime).format('YYYY-MM-DD')
  //   },
  // },
]

const formatTime = ({ exprieTime }: any) => {
  return exprieTime === -1 ? '无期限' : moment(exprieTime).format('YYYY-MM-DD')
}

const isOverTime = ({ exprieTime }: any) => {
  if (exprieTime !== -1) {
    const now = moment().valueOf()
    const time = moment(exprieTime).valueOf()
    return time < now ? '(已过期)' : ''
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_table, {
      data: tableData.value,
      border: true,
      style: {"width":"100%","margin-top":"20px"}
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_el_empty, { description: "暂无数据" })
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
          return _createVNode(_component_el_table_column, _mergeProps({ key: index }, {
          ...item,
        }, { "show-overflow-tooltip": "" }), null, 16)
        }), 64)),
        _createVNode(_component_el_table_column, {
          prop: "exprieTime",
          label: "到期时间",
          width: "400"
        }, {
          default: _withCtx((scoped) => [
            _createElementVNode("p", _hoisted_3, [
              _createTextVNode(_toDisplayString(formatTime(scoped.row)) + " ", 1),
              _createElementVNode("span", null, _toDisplayString(isOverTime(scoped.row)), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}
}

})